import React from "react";

import { ThemeSelect, About } from "@tableplus/toolkit";
import { DivGrow } from "@moai/core";
import { Prefs } from "prefs/prefs";

import s from "./toolbar.module.scss";

interface Props {
    prefs: Prefs;
}

export const Toolbar: React.FC<Props> = ({ prefs }) => (
    <div className={s.toolbar}>
        <ThemeSelect theme={prefs.theme} setTheme={prefs.setTheme} />
        <DivGrow />
        <About />
    </div>
);
